import axios from '../../helpers/axios-setup';

export const getVariantsByProductModelId = (id: number) => axios.get(`/product-model-variants/product-model/${id}`);
